export default __webpack_public_path__ + "static/media/backgroundMd.b1f2dd42.webp";